import equalsIgnoreCase from './equals-ignore-case';

import { DATE } from '../../common/constants';

export default function isDateAxis(axisOptions, sampleCategory) {
    var type = axisOptions.type;
    var dateCategory = sampleCategory instanceof Date;

    return (!type && dateCategory) || equalsIgnoreCase(type, DATE);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-gauges/node_modules/@progress/kendo-charts/dist/es/chart/utils/is-date-axis.js
// module id = 995
// module chunks = 29